import * as QueriesA from './queries'
export type { APITypes } from '@qflow/api'
export * from './auth'
export * from './api'
export * from './useApiQuery'

// jest.spyOn can't work with `export { Queries }` syntax https://github.com/facebook/jest/issues/11019
export const Queries = { ...QueriesA }
